import { useEffect, useState, useCallback } from "react";
import { FiSearch, FiX, FiEye, FiMaximize2 } from "react-icons/fi";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import Spinner from "../../utils/Loader";

function AllAgentShip() {
  const [agentships, setAgentships] = useState([]);
  const [statusManage, setStatusManage] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });

  // Modals state
  const [detailModal, setDetailModal] = useState(null);
  const [previewImage, setPreviewImage] = useState(null); // For Full Screen Image
  const status = detailModal?.status?.toLowerCase();
  console.log("detailModal", detailModal);

  const fetchAgentships = useCallback(async (page = 1, search = "") => {
    setIsLoading(true);
    try {
      const response = await makeRequestAuth(
        "get",
        `/admin/getAgentshipsList?page=${page}&limit=10&search=${search}`,
      );
      const { list, pagination: pagData } = response?.data || {};

      setAgentships(list || []);
      setPagination(pagData || { page: 1, totalPages: 1 });
    } catch (err) {
      showErrorToast("Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleApproveStatus = (data) => {
    const resData = data?.teamMembers?.find((ele) => ele.status !== "active");

    if (!resData) {
      setStatusManage(true);
    }
    setDetailModal(data);
  };

  useEffect(() => {
    fetchAgentships(pagination.page, searchTerm);
  }, [fetchAgentships, pagination.page, searchTerm]);

  const handleMemberStatusUpdate = async (memberIndex, newStatus) => {
    try {
      setIsLoading(true);

      await makeRequestAuth("post", "/admin/updateAgentshipStatus", {
        agentshipId: detailModal._id,
        memberIndex: memberIndex,
        memberStatus: newStatus,
      });

      const updatedMembers = [...detailModal.teamMembers];
      updatedMembers[memberIndex].status = newStatus;

      setDetailModal({
        ...detailModal,
        teamMembers: updatedMembers,
      });

      const resData = updatedMembers?.find((ele) => ele.status !== "active");

      if (!resData) {
        setStatusManage(true);
      }

      showSuccessToast(`Member ${newStatus} successfully`);
    } catch (err) {
      console.log("err", err);
      showErrorToast("Failed to update member status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleMainStatusUpdate = async (status) => {
    try {
      setIsLoading(true);

      const response = await makeRequestAuth(
        "post",
        "/admin/updateAgentshipStatus",
        {
          agentshipId: detailModal._id,
          mainStatus: status,
        },
      );

      console.log("response", response.data.message);

      if (!response.data.error) {
        setAgentships((prev) =>
          prev.map((a) => (a._id === detailModal._id ? { ...a, status } : a)),
        );

        setDetailModal(null);

        showSuccessToast(`Application ${status} successfully`);

        fetchAgentships(pagination.page, searchTerm); // refresh table
      } else {
        showErrorToast(response.data.message);
      }
    } catch (err) {
      console.log("err", err);
      showErrorToast("Action failed");
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const map = {
      approved: "bg-green-100 text-green-700",
      active: "bg-green-100 text-green-700",
      rejected: "bg-red-100 text-red-700",
      inactive: "bg-red-100 text-red-700",
      pending: "bg-orange-100 text-orange-700",
    };
    return `px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${map[status] || "bg-gray-100"}`;
  };

  // if (isLoading && agentships.length === 0) return <Spinner />;

  return (
    <>
      {" "}
      {isLoading && agentships.length === 0 ? (
        <Spinner />
      ) : (
        <div className="p-4 md:p-8 bg-[#F8FAFC] dark:bg-[#0f172a] min-h-screen">
          <ToastContainer />

          <div className="max-w-7xl mx-auto">
            {/* Header & Search */}
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
              <h1 className="text-xl font-black dark:text-white uppercase tracking-tighter">
                AgentShip Requests
              </h1>
              <div className="relative w-full md:w-80">
                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search..."
                  className="w-full pl-10 pr-4 py-2.5 rounded-xl border-none bg-white dark:bg-gray-800 shadow-sm focus:ring-2 focus:ring-blue-500"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) =>
                    e.key === "Enter" && fetchAgentships(1, searchTerm)
                  }
                />
              </div>
            </div>

            {/* Table */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
              <table className="w-full text-left">
                <thead className="bg-gray-50 dark:bg-gray-700/50 text-gray-400 text-[10px] font-bold uppercase tracking-widest">
                  <tr>
                    <th className="px-6 py-4">Applicant</th>
                    <th className="px-6 py-4">Telegram</th>
                    <th className="px-6 py-4">Status</th>
                    <th className="px-6 py-4 text-right">Review</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50 dark:divide-gray-700">
                  {agentships.map((item) => (
                    <tr
                      key={item._id}
                      className="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition"
                    >
                      <td className="px-6 py-4 font-bold dark:text-gray-200">
                        {item.applicantUserId}
                      </td>
                      <td className="px-6 py-4 text-blue-500 font-medium">
                        {item.telegramId}
                      </td>
                      <td className="px-6 py-4">
                        <span className={getStatusBadge(item.status)}>
                          {item.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() => handleApproveStatus(item)}
                          className="p-2.5 bg-gray-100 dark:bg-gray-700 rounded-xl hover:bg-blue-600 hover:text-white transition group"
                        >
                          <FiEye className="group-hover:scale-110 transition" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* DETAIL MODAL */}
          {detailModal && (
            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 flex justify-center items-center p-4">
              <div className="bg-white dark:bg-gray-900 w-full max-w-5xl max-h-[90vh] rounded-3xl shadow-2xl overflow-hidden flex flex-col">
                <div className="p-6 border-b dark:border-gray-800 flex justify-between items-center bg-white dark:bg-gray-800">
                  <h2 className="text-xl font-black dark:text-white">
                    Reviewing: {detailModal.applicantUserId}
                  </h2>
                  <button
                    onClick={() => setDetailModal(null)}
                    className="p-2 hover:bg-red-50 text-gray-400 hover:text-red-500 rounded-full transition text-2xl"
                  >
                    ×
                  </button>
                </div>
                <div className="p-6 overflow-y-auto bg-gray-50/50 dark:bg-gray-950 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {detailModal.teamMembers.map((member, idx) => (
                    <div
                      key={member._id}
                      className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 p-3 shadow-sm group"
                    >
                      <div
                        onClick={() => setPreviewImage(member.imageUrl)}
                        className="relative h-44 rounded-xl overflow-hidden bg-black cursor-zoom-in mb-4"
                      >
                        <img
                          src={member.imageUrl}
                          alt="Proof"
                          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                        />
                        <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                          <FiMaximize2 className="text-white text-3xl" />
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-4 px-1">
                        <span className="text-sm font-bold dark:text-white">
                          {member.userId}
                        </span>
                        <span className={getStatusBadge(member.status)}>
                          {member.status}
                        </span>
                      </div>
                      <div className="mt-4">
                        {/* Agar status pending hai toh Buttons dikhao */}
                        {member.status === "pending" ? (
                          <div className="flex gap-2">
                            <button
                              onClick={() =>
                                handleMemberStatusUpdate(idx, "active")
                              }
                              className="flex-1 py-2 bg-emerald-50 text-emerald-600 hover:bg-emerald-600 hover:text-white rounded-xl text-[10px] font-black uppercase transition border border-emerald-100"
                            >
                              Active
                            </button>
                            <button
                              onClick={() =>
                                handleMemberStatusUpdate(idx, "inactive")
                              }
                              className="flex-1 py-2 bg-red-50 text-red-600 hover:bg-red-600 hover:text-white rounded-xl text-[10px] font-black uppercase transition border border-red-100"
                            >
                              Inactive
                            </button>
                          </div>
                        ) : (
                          /* Agar status change ho gaya hai toh Badge dikhao */
                          <div
                            className={`text-center py-2 rounded-xl text-[10px] font-black uppercase border ${
                              member.status === "active"
                                ? "bg-emerald-100 text-emerald-700 border-emerald-200"
                                : member.status === "inactive"
                                  ? "bg-red-100 text-red-700 border-red-200"
                                  : "bg-gray-100 text-gray-600 border-gray-200"
                            }`}
                          >
                            {member.status}
                          </div>
                        )}
                      </div>{" "}
                    </div>
                  ))}
                </div>

                {status === "approved" && (
                  <div className="p-6 bg-white dark:bg-gray-800 flex justify-end gap-3 border-t dark:border-gray-700">
                    <div className="px-8 py-3 bg-blue-600 text-white rounded-2xl font-black shadow-lg shadow-blue-500/30">
                      Approved
                    </div>
                  </div>
                )}
                {status === "rejected" && (
                  <div className="p-6 bg-white dark:bg-gray-800 flex justify-end gap-3 border-t dark:border-gray-700">
                    <div className="px-8 py-3 bg-red-100 text-red-600 rounded-2xl font-black">
                      Rejected
                    </div>
                  </div>
                )}
                {status === "submitted" && (
                  <div className="p-6 bg-white dark:bg-gray-800 flex justify-end gap-3 border-t dark:border-gray-700">
                    <div className="px-8 py-3 bg-yellow-500 text-white rounded-2xl font-black">
                      Submitted
                    </div>
                  </div>
                )}
                {/* {status === "completed" && (
                  <div className="p-6 bg-white dark:bg-gray-800 flex justify-end gap-3 border-t dark:border-gray-700">
                    <div className="px-8 py-3 bg-green-600 text-white rounded-2xl font-black">
                      Completed
                    </div>
                  </div>
                )} */}
                {["pending", "completed"].includes(status) && (
                  <div className="p-6 bg-white dark:bg-gray-800 flex justify-end gap-3 border-t dark:border-gray-700">
                    {statusManage && (
                      <button
                        onClick={() => handleMainStatusUpdate("approved")}
                        className="px-8 py-3 bg-blue-600 text-white rounded-2xl font-black"
                      >
                        Approve All
                      </button>
                    )}

                    <button
                      onClick={() => handleMainStatusUpdate("rejected")}
                      className="px-8 py-3 bg-red-100 text-red-600 rounded-2xl font-black"
                    >
                      Reject All
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* FULL SCREEN IMAGE PREVIEW LIGHTBOX */}
          {previewImage && (
            <div
              className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-4 animate-in fade-in duration-300"
              onClick={() => setPreviewImage(null)}
            >
              <button
                className="absolute top-6 right-6 text-white text-4xl hover:text-red-500 transition"
                onClick={() => setPreviewImage(null)}
              >
                <FiX />
              </button>
              <img
                src={previewImage}
                alt="Full Preview"
                className="max-w-full max-h-full rounded-lg shadow-2xl object-contain animate-in zoom-in duration-300"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default AllAgentShip;
